import * as React from 'react';
import { getQueryTableAutomationId, QueryTableAutomationId } from '../Helpers/AutomationIdHelper';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from '@fortawesome/free-solid-svg-icons';

export interface HamburgerProps {
    children: any;
    automationId?: string;
    disabled?: boolean;
    contextMenuLeftAligned?: boolean;
}

export const HamburgerMenu = ({ children, automationId = `${getQueryTableAutomationId(QueryTableAutomationId.Options)}`, disabled = false, contextMenuLeftAligned = false }: HamburgerProps) => {
    const ref = React.useRef(null);
    const [visible, setVisible] = React.useState<boolean>(true);
    React.useEffect(() => {
        if (!ref.current)
            return;
        setVisible(ref?.current?.children.length > 0);

        if (contextMenuLeftAligned) {
            ref.current.style.setProperty("left", "unset", "important");
        } 

    }, [ref.current]);

    return (
        !visible ? null :
            <div className="btn-group" role="group">
                <ul className="dropdown-menu scrollable-menu pull-right" role="menu" ref={ref}>
                    {children}
                </ul>
                <button
                    disabled={disabled}
                    data-automationid={automationId}
                    type="button"
                    className="btn btn-primary btn-xs dropdown-toggle"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                >
                    <FontAwesomeIcon aria-hidden="true" icon={faBars} />
                </button>
            </div>
    );
}



